"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettlementPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const settlement_1 = require("../../sections/settlement");
const SettlementContext_1 = require("../../sections/settlement/context/SettlementContext");
const SettlementPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(SettlementContext_1.SettlementProvider, { children: (0, jsx_runtime_1.jsx)(settlement_1.SettlementComponent, {}) }));
};
exports.SettlementPage = SettlementPage;
